import { Navigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/authProvider";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const { auth, setAuth } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      // Check if we already have auth in cnotext
      if (auth.accessToken) {
        setIsLoading(false);
        return;
      }

      // Check localStorage for token
      const token = localStorage.getItem("jwtToken");

      if (!token) {
        // No token found = user is not authenticated
        setIsLoading(false);
        return;
      }

      try {
        // Decode and validate token
        const decodedToken = jwtDecode(token);

        // Check if token is expired
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          // Token expired
          localStorage.removeItem("jwtToken");
          setAuth({});
          setIsLoading(false);
          return;
        }

        // Token is valid - Restore auth context from token
        setAuth({
          user: decodedToken.username,
          accessToken: token,
          user_id: decodedToken.user_id,
        });
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("jwtToken");
        setAuth({});
      }

      setIsLoading(false);
    };

    validateToken();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // replace with spinner
  }

  // Check if user is authenticated
  const token = localStorage.getItem("jwtToken");
  if (!token && !auth.accessToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
